import { app } from '../../../../../../app';
import { Controller } from './move-users-to-label.controller';

app.component('companyUserLabelMembersMove', {
    bindings: {
       	users: '<',
        companyId: '<',
        labels: '<',
		userLabelId:'<'
    },
    controller: Controller,
    templateUrl: require('./move-users-to-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/move/move-users-to-label.component..js